import React, { useState, useEffect } from "react";
import { Select } from "../../../ReactSelect/ReactSelect";
import { Label } from "reactstrap";

const AgentSelector = ({ label, agents, handleClick, filterItems }) => {
    const [options, setOptions] = useState([]);
    const [filteredOptions, setFilteredOptions] = useState(undefined);

    useEffect(() => {
        if (agents) {
            setOptions(
                agents.map((agent) => {
                    const { agentName, brokerAgentStates } = agent || {};
                    const agentState =
                        Array.isArray(brokerAgentStates) &&
                        brokerAgentStates.length > 0
                            ? ` (${brokerAgentStates.join("/")})`
                            : "";
                    return {
                        label: `${agentName}${agentState}`,
                        value: { type: "agent", ...agent },
                    };
                })
            );
        }
    }, [agents]);

    useEffect(() => {
        if (filterItems?.nicheItemId) {
            setFilteredOptions(
                options.filter((options) =>
                    options.value.brokerAgentNicheItems.includes(
                        filterItems.nicheItemId
                    )
                )
            );
        } else if (filterItems?.stateId) {
            setFilteredOptions(
                options.filter((options) =>
                    options.value.brokerAgentStates.includes(
                        filterItems.stateId
                    )
                )
            );
        } else {
            setFilteredOptions(options);
        }
    }, [options, filterItems]);

    const keyDownHandler = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
        }
    };

    const sort = (list, sortType) => {
        const newList = [...list];
        if (sortType === "firstName") {
            return newList.sort((a, b) =>
                a.value.firstName < b.value.firstName ? -1 : 1
            );
        } else if (sortType === "lastName") {
            return newList.sort((a, b) =>
                a.value.lastName < b.value.lastName ? -1 : 1
            );
        } else {
            return newList;
        }
    };

    const sortedOptions =
        filterItems.sort && filterItems.sort !== "random"
            ? sort(filteredOptions || options, filterItems.sort)
            : filteredOptions || options;

    return (
        <div className="w-100" data-test="select-agent">
            <Label>{label}</Label>
            <Select
                className="w-100 react-select"
                placeholder={label}
                options={sortedOptions}
                isClearable={true}
                onChange={(item) => handleClick(item?.value?.id)}
                onKeydown={keyDownHandler}
            />
        </div>
    );
};

export default AgentSelector;
